import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { Button, Form, Input, Modal, Select, Space } from "antd";
import {
  ANumberManageStore,
  UserAccountStore,
} from "../../../../store";

function UpdateOrAdd(props: any) {
  const form = Form.useFormInstance();
  const { Option } = Select;

  const getFormData = (changeValue: any, allValues: any) => {
    allValues.phoneNumberNo = UserAccountStore.lookPower.phoneNumberNo;
    UserAccountStore.setLookPower({ ...allValues, ...changeValue });
  };
  const submitPower = () => {
    if(UserAccountStore.lookPower.phoneNumber && UserAccountStore.lookPower.callInitializerNumberPoolNo && UserAccountStore.lookPower.status && UserAccountStore.lookPower.carrier ){
      if (UserAccountStore.addOrUpdateModal.update ) {
        ANumberManageStore.editAPoolNumber(UserAccountStore.lookPower);
        UserAccountStore.addOrUpdateModal.close();
      } else {
        if(UserAccountStore.lookPower.numberType){
          ANumberManageStore.addAPoolNumber(UserAccountStore.lookPower);
          UserAccountStore.addOrUpdateModal.close();
        }
      }
    }

  };

  return (
    <Fragment>
      <Modal
        width={520}
        centered
        title={UserAccountStore.addOrUpdateModal.update ? "编辑" : "新增"}
        open={UserAccountStore.addOrUpdateModal.isOpen}
        destroyOnClose={true}
        onCancel={() => UserAccountStore.addOrUpdateModal.close()}
        footer={null}
      >
        {
          <Form
            form={form}
            labelCol={{ flex: "110px" }}
            labelWrap
            initialValues={UserAccountStore.lookPower}
            wrapperCol={{ flex: 1 }}
            onValuesChange={getFormData}
            style={{marginTop:'10px'}}
          >
            <Form.Item
              label="号码"
              name="phoneNumber"
              rules={[{ required: true, message: "请输入号码" }]}
            >
              <Input style={{ width: "330px" }} showCount maxLength={50} disabled={UserAccountStore.addOrUpdateModal.update ? true : false }/>
            </Form.Item>
            <Form.Item
              label="所属A池"
              name="callInitializerNumberPoolNo"
              rules={[{ required: true, message: "请所属A池" }]}
            >
              <Select style={{ width: "330px" }} onChange={UserAccountStore.handleChange}>
                {ANumberManageStore.getAllAPoolWriteInfo.map(
                  (value: any, index: any) => {
                    return (
                      <Option value={value.no} key={value.no}>
                        {value.name}
                      </Option>
                    );
                  }
                )}
              </Select>
            </Form.Item>
            <Form.Item
              label="号码状态"
              name="status"
              rules={[{ required: true, message: "请选择号码状态" }]}
            >
              <Select style={{ width: "330px" }} allowClear>
                <Option value={"1"}>待上架</Option>
                <Option value={"2"}>已上架</Option>
                <Option value={"3"}>已禁用</Option>
              </Select>
            </Form.Item>
            {UserAccountStore.addOrUpdateModal.add && <Form.Item
              label="号码类型"
              name="numberType"
              rules={[{ required: true, message: "请选择号码类型" }]}
            >
              <Select style={{ width: "330px" }} allowClear>
                <Option value={"0"}>移动电话</Option>
                <Option value={"1"}>固定电话</Option>
              </Select>
            </Form.Item>}
            <Form.Item
              label="基础运营商"
              name="carrier"
              rules={[{ required: true, message: "基础运营商" }]}
            >
              <Select style={{ width: "330px" }} allowClear>
                <Option value={"电信"}>电信</Option>
                <Option value={"移动"}>移动</Option>
                <Option value={"联通"}>联通</Option>
              </Select>
            </Form.Item>
            <Form.Item label="备注" name="remark" >
              <Input style={{ width: "330px" }} showCount maxLength={50} />
            </Form.Item>
            <Form.Item
              style={{ textAlign: "right" }}
              wrapperCol={{ span: 18, offset: 6 }}
            >
              <Space>
                <Button
                  htmlType="reset"
                  onClick={() => UserAccountStore.addOrUpdateModal.close()}
                >
                  取消
                </Button>
                <Button type="primary" htmlType="submit" onClick={submitPower}>
                  确定
                </Button>
              </Space>
            </Form.Item>
          </Form>
        }
      </Modal>
    </Fragment>
  );
}

export default observer(UpdateOrAdd);
